import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio/react'
import { useAppModule } from '../appContext.ts'
import { Dialog } from '../../shared/ui/dialog/dialog.tsx'
import { ContactsBlock } from '../contacts/contactsBlock.tsx'

export function NoSubscriptionOverlay() {
  const { authStore } = useAppModule()
  const subscriptionService = useAppModule().subscriptionService()
  const state = useSnapshot(authStore.state)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!authStore.isLogin() || authStore.state.isAnon) {
      setChecked(true)
      return
    }

    let cancelled = false
    void (async () => {
      try {
        const subscription = await subscriptionService.getActiveSubscription()
        if (!cancelled) {
          authStore.setSubscribeState(!!subscription)
        }
      } catch {
        if (!cancelled) {
          authStore.setSubscribeState(false)
        }
      } finally {
        if (!cancelled) {
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [authStore, subscriptionService])

  if (
    !checked ||
    !state.isLogin ||
    state.isAnon ||
    state.isActiveSubscribe
  ) {
    return null
  }

  return (
    <Dialog.Root open>
      <Dialog.Content
        closable={false}
        overlayBlur
        // Above react-joyride (overlay ~100, tooltip ~200)
        overlayClassName="z-[300]"
        className="z-[300] min-w-0 w-[min(92vw,440px)] max-w-[440px] px-24 py-32 text-center"
      >
        <p className="whitespace-pre-wrap text-center text-16 font-medium leading-relaxed text-black">
          Уважаемый пользователь, в ближайшее время мы свяжемся с вами, чтобы
          предоставить доступ в продукт.
          {'\n\n'}
          Если есть вопросы, напишите нам в Телеграм или Макс — мы оперативно
          ответим 🙌
        </p>
        <ContactsBlock className="mt-28" />
      </Dialog.Content>
    </Dialog.Root>
  )
}
